interface Project {
  title: string;
  link: string;
  image: string;
}

interface InfiniteCarouselProps {
  items: Project[];
}

export const InfiniteCarousel = ({ items }: InfiniteCarouselProps) => (
  <div className="relative py-8 overflow-hidden">
    {/* Left Fade */}
    <div className="absolute left-0 top-0 h-full w-16 bg-gradient-to-r from-xencode-black to-transparent z-10 pointer-events-none" />

    {/* Right Fade */}
    <div className="absolute right-0 top-0 h-full w-16 bg-gradient-to-l from-xencode-black to-transparent z-10 pointer-events-none" />

    {/* Carousel */}
    <div className="carousel-wrapper flex">
      <div className="carousel-inner flex animate-scroll gap-6 px-4">
        {items.concat(items).map((item, index) => (
          <div className="carousel-item flex-shrink-0 w-80 h-48" key={index}>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-contain hover:opacity-80 transition-opacity duration-300"
              />
              <h2 className="text-center mt-1 text-white font-bold text-sm">{item.title}</h2>
            </a>
          </div>
        ))}
      </div>
    </div>
  </div>
);
